import { cn } from '@/lib/utils';

export const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    'flex w-full min-w-0 items-center rounded border border-transparent px-2 py-1 text-sm text-foreground transition-colors hover:bg-selected-soft',
    isActive && 'border-border bg-background'
  );
